let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("ryge4")).then(() => parcelRequire('eZIhV'));